import React from 'react';
import Table from './table';
const Page = (props) => (
  <main className="main" id="main">
    <div className="page-manage-set">
      <div className="sec sec-top-tab">
        <div className="sec-breadcrumb radius-collapse">
          <div className="breadcrumb">
            <a href="#/system/leadsForward/Api" className="breadcrumb-back" role="button">
              <i className="icon icon-breadcrumb-back"></i>
            </a>
            <ol role="navigation" aria-label="breadcrumbs" className="breadcrumbs">
              <li>
                <a role="button" href="#/system/leadsForward/Api">
                  线索转发设置
                </a>
              </li>
              <li>
                <a className="current">推送接口配置</a>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div className="secs">
        <div className="sec">
          <div className="card">
            <Table />
          </div>
        </div>
      </div>
    </div>
  </main>
);

export default Page;
